import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "min-h-screen bg-black-primary text-white p-6 font-inter" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4" }
const _hoisted_4 = { class: "text-3xl md:text-4xl font-bold text-gold mb-2 animate-fade-in" }
const _hoisted_5 = { class: "flex justify-center mb-8 animate-fade-in" }
const _hoisted_6 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl shadow-lg px-8 py-6 flex flex-col items-center w-full max-w-md relative" }
const _hoisted_7 = {
  key: 0,
  class: "h-10 w-40 bg-zinc-200 rounded animate-pulse mb-2"
}
const _hoisted_8 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_9 = { class: "text-2xl font-bold tracking-widest text-black px-4 py-2 rounded-lg border-2 border-white select-all" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" }
const _hoisted_14 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center animate-pop-in" }
const _hoisted_15 = { class: "text-4xl font-bold" }
const _hoisted_16 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center animate-pop-in delay-100" }
const _hoisted_17 = { class: "text-4xl font-bold" }
const _hoisted_18 = { class: "bg-gradient-to-br from-[#BC8809] to-gold-customYellow rounded-2xl p-6 shadow-lg flex flex-col items-center animate-pop-in delay-200" }
const _hoisted_19 = { class: "text-4xl font-bold" }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-16 animate-fade-in"
}
const _hoisted_21 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 gap-8"
}
const _hoisted_22 = { class: "bg-neutral-800 rounded-2xl p-6 shadow-lg animate-fade-in min-h-80" }
const _hoisted_23 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_24 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_25 = {
  key: 2,
  class: "w-full text-left"
}
const _hoisted_26 = { class: "py-2" }
const _hoisted_27 = { class: "py-2" }
const _hoisted_28 = { class: "py-2" }
const _hoisted_29 = { class: "bg-neutral-800 rounded-2xl p-6 shadow-lg animate-fade-in" }
const _hoisted_30 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_31 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_32 = {
  key: 2,
  class: "w-full text-left"
}
const _hoisted_33 = { class: "py-2" }
const _hoisted_34 = { class: "py-2" }
const _hoisted_35 = { class: "py-2" }
const _hoisted_36 = { class: "py-2" }

import {
  ref, onMounted, nextTick, computed,
} from 'vue';
import UserService from '@/service/user.service';
import RequestService from '@/service/request.service';
import Chart from 'chart.js/auto';
import { RequestStatus } from '@/types/order';


export default /*@__PURE__*/_defineComponent({
  __name: 'PartnerDashboard',
  setup(__props) {

const leads = ref<any[]>([]);
const requests = ref<any[]>([]);
const partnerName = ref('');
const loadingLeads = ref(true);
const loadingRequests = ref(true);
const chartRef = ref<HTMLCanvasElement | null>(null);
const chartInstance = ref<any>(null);
const referralCode = ref<string | null>(null);
const loadingReferralCode = ref(true);
const copied = ref(false);

const userId = localStorage.getItem('userId');

function formatDate(date: any) {
  if (!date) return '—';
  if (date.toDate) return date.toDate().toLocaleDateString();
  if (date.seconds) return new Date(date.seconds * 1000).toLocaleDateString();
  return new Date(date).toLocaleDateString();
}

function getLeadName(uid: string) {
  const lead = leads.value.find((l) => l.userId === uid);
  return lead ? lead.fullName : '—';
}

function statusClass(status: number) {
  switch (status) {
    case RequestStatus.Completed:
      return 'text-green-400 font-semibold';
    case RequestStatus.Processing:
      return 'text-yellow-400 font-semibold';
    case RequestStatus['In Progress']:
    case RequestStatus['Waiting For Payment']:
      return 'text-blue-400 font-semibold';
    case RequestStatus.Cancelled:
      return 'text-red-400 font-semibold';
    default:
      return 'text-gray-300';
  }
}

const conversionRate = computed(() => {
  if (!leads.value.length) return 0;
  const leadsWithRequests = leads.value.filter((lead) => requests.value.some((r) => r.userId === lead.userId && r.status === 'paid'));
  return Math.round((leadsWithRequests.length / leads.value.length) * 100);
});

function renderChart() {
  if (!chartRef.value) return;
  if (chartInstance.value) {
    chartInstance.value.destroy();
  }
  // Group leads by registration month
  const monthly: Record<string, number> = {};
  leads.value.forEach((lead) => {
    let date = lead.registrationDate;
    if (date?.toDate) date = date.toDate();
    else if (date?.seconds) date = new Date(date.seconds * 1000);
    else date = new Date(date);
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0',
    )}`;
    monthly[key] = (monthly[key] || 0) + 1;
  });
  const labels = Object.keys(monthly).sort();
  const data = labels.map((l) => monthly[l]);
  chartInstance.value = new Chart(chartRef.value, {
    type: 'line',
    data: {
      labels,
      datasets: [
        {
          label: 'Leads',
          data,
          borderColor: '#C4992A',
          backgroundColor: 'rgba(196,153,42,0.2)',
          tension: 0.4,
          fill: true,
          pointBackgroundColor: '#fff',
          pointBorderColor: '#C4992A',
          pointRadius: 5,
        },
      ],
    },
    options: {
      plugins: {
        legend: {
          labels: { color: '#C4992A', font: { size: 16, weight: 'bold' } },
        },
      },
      scales: {
        x: { ticks: { color: '#fff' }, grid: { color: '#333' } },
        y: { ticks: { color: '#fff' }, grid: { color: '#333' } },
      },
      animation: { duration: 1200, easing: 'easeOutQuart' },
      responsive: true,
      maintainAspectRatio: false,
    },
  });
}

async function loadLeadsAndRequests() {
  loadingLeads.value = true;
  loadingRequests.value = true;
  if (!userId) return;
  // Fetch leads
  const leadsResult = await UserService.getUsersReferredBy(userId);
  leads.value = leadsResult;
  partnerName.value = leadsResult[0]?.referredByName || leadsResult[0]?.partnerName || '';
  loadingLeads.value = false;
  // Fetch requests for those leads
  const leadUserIds = leadsResult.map((l: any) => l.userId);
  if (leadUserIds.length) {
    requests.value = await RequestService.getRequestsByUserIds(leadUserIds);
  } else {
    requests.value = [];
  }
  loadingRequests.value = false;
  // await nextTick();
  // renderChart();
}

async function fetchReferralCode() {
  loadingReferralCode.value = true;
  referralCode.value = await UserService.getReferralCodeByUserId(userId!);
  loadingReferralCode.value = false;
}

function copyReferralCode() {
  if (referralCode.value) {
    const message = `Download TALAB and use my referral code: ${referralCode.value}\n\nGet exclusive access to premium services and earn rewards!\n\nhttps://talabapp.co.uk/`;
    navigator.clipboard.writeText(message);
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 1500);
  }
}

onMounted(() => {
  fetchReferralCode();
  loadLeadsAndRequests();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_4, " Welcome, " + _toDisplayString(partnerName.value || "Partner"), 1),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-lg text-gray-300 animate-fade-in-slow" }, " Your personal dashboard to track your leads and their requests. ", -1))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: "TALAB Logo",
          class: "w-24 md:w-32 animate-fade-in"
        }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-lg font-semibold text-black mb-2" }, "Your Referral Code", -1)),
          (loadingReferralCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(referralCode.value || "N/A"), 1),
                _createElementVNode("button", {
                  onClick: copyReferralCode,
                  class: "ml-2 px-3 py-2 rounded-lg bg-gold-primary text-black font-semibold hover:bg-gold-secondary transition border border-gold-secondary focus:outline-none"
                }, [
                  (!copied.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Copy"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "Copied!"))
                ])
              ])),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-black/60 mt-2" }, "Share this code with your leads.", -1))
        ])
      ]),
      (leads.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(leads.value.length), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "Total Leads", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(requests.value.length), 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "Total Requests", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(conversionRate.value) + "%", 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-lg font-medium mt-2" }, "Lead Conversion", -1))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[7] || (_cache[7] = [
            _createElementVNode("h2", { class: "text-2xl font-semibold text-gold mb-2" }, "No referrals yet!", -1),
            _createElementVNode("p", { class: "text-lg text-gray-300 mb-4" }, " Once you refer users, you’ll see your stats and leads here. ", -1),
            _createElementVNode("span", { class: "text-sm text-gray-500" }, "Share your referral link to get started!", -1)
          ]))),
      (leads.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4 text-gold" }, "Your Leads", -1)),
              (loadingLeads.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Loading leads..."))
                : (leads.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No leads found. "))
                  : (_openBlock(), _createElementBlock("table", _hoisted_25, [
                      _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", { class: "text-gold border-b border-gold/30" }, [
                          _createElementVNode("th", { class: "py-2" }, "Name"),
                          _createElementVNode("th", { class: "py-2" }, "Email"),
                          _createElementVNode("th", { class: "py-2" }, "Registered")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leads.value, (lead) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: lead.id,
                            class: "border-b border-zinc-700 hover:bg-zinc-800 transition"
                          }, [
                            _createElementVNode("td", _hoisted_26, _toDisplayString(lead.fullName), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(lead.email), 1),
                            _createElementVNode("td", _hoisted_28, _toDisplayString(formatDate(lead.registrationDate)), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4 text-gold" }, "Leads' Requests", -1)),
              (loadingRequests.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Loading requests... "))
                : (requests.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, " No requests found. "))
                  : (_openBlock(), _createElementBlock("table", _hoisted_32, [
                      _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", { class: "text-gold border-b border-gold/30" }, [
                          _createElementVNode("th", { class: "py-2" }, "Lead"),
                          _createElementVNode("th", { class: "py-2" }, "Service"),
                          _createElementVNode("th", { class: "py-2" }, "Date"),
                          _createElementVNode("th", { class: "py-2" }, "Status")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (req) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: req.id,
                            class: "border-b border-zinc-700 hover:bg-zinc-800 transition"
                          }, [
                            _createElementVNode("td", _hoisted_33, _toDisplayString(getLeadName(req.userId)), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(req.title || req.service || "—"), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(formatDate(req.createdAt)), 1),
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("span", {
                                class: _normalizeClass(statusClass(req.status))
                              }, _toDisplayString(_unref(RequestStatus)[req.status]), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})